import React, { useEffect, useRef, useState } from 'react';
import { DatePicker, Form, TimePicker } from 'antd';
import { CalendarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { MomentToDate } from './index';
import 'moment/locale/fr';
import locale_fr from 'antd/lib/date-picker/locale/fr_FR';
import ReactDOM from 'react-dom';
import DdnField from '../components/DdnField';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const {data} = props

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined/>,
                }
            }

            var prefix = "[DATE]_"

            const range = data.range || false
            var withTime = false
            var picker = "date"
            var format = "DD/MM/YYYY"
            var disabledDate = (d) => false
            var showNow = true
            var component = "DATE"

            switch (data.dateFilter) {
                case formPlugin.DATE_FILTER_SELECT[0]:
                    showNow = false
                    disabledDate = (d) => d > new Date()
                    break;
                case formPlugin.DATE_FILTER_SELECT[1]:
                    showNow = false
                    disabledDate = (d) => d < new Date()
                    break;
                case formPlugin.DATE_FILTER_SELECT[2]:
                    showNow = true
                    var date = new Date()
                    date.setDate(date.getDate() + 1)
                    disabledDate = (d) => d > date
                    break;
                case formPlugin.DATE_FILTER_SELECT[3]:
                    showNow = true
                    var date = new Date()
                    date.setDate(date.getDate() + 1)
                    disabledDate = (d) => d < date
                    break;
            }

            switch (data.picker) {
                case formPlugin.DATE_PICKER[0]:
                    prefix = "[DATETIME]_"
                    withTime = true
                    format = "DD/MM/YYYY HH:mm"
                    break;
                case formPlugin.DATE_PICKER[1]:
                    prefix = "[YEAR]_"
                    picker = "year"
                    format = "YYYY"
                    break;
                case formPlugin.DATE_PICKER[2]:
                    prefix = "[MONTH]_"
                    picker = "month"
                    format = "MM/YYYY"
                    break;
                case formPlugin.DATE_PICKER[3]:
                    prefix = "[TIME]_"
                    picker = "time"
                    component = "TIME"
                    format = "HH:mm"
                    break;
            }

            var InputComponent
            if (component === "DATE" && !range) {
                InputComponent = DatePicker
            }
            if (component === "DATE" && range) {
                InputComponent = DatePicker.RangePicker
            }
            if (component === "TIME" && !range) {
                InputComponent = TimePicker
            }
            if (component === "TIME" && range) {
                InputComponent = TimePicker.RangePicker
            }

            const listFieldProps = listField ? listField : null
            const finalName = prefix + data.fieldKey

            if (prefix === "[DATE]_" && !range) {
                return (
                    <div ref={(ref) => containerRef.current = ref}>
                        <Form.Item noStyle shouldUpdate>
                            {(_form) => {
                                const fieldName = listField ? [listField.name, finalName].flat() : finalName
                                let _value = _form.getFieldValue(fieldName)
                                if (!_value && data.defaultNow) {
                                    _form.setFieldValue(fieldName, new Date())
                                }

                                return (
                                    <Form.Item
                                        {...listFieldProps}
                                        label={`${data.label || t`Question`} :`}
                                        name={fieldName}
                                        rules={[{ required: data.required || false, message: t`Ce champ est obligatoire` }]}
                                        tooltip={tooltip}
                                    >
                                        <DdnField/>
                                    </Form.Item>
                                )
                            }}
                        </Form.Item>
                    </div>
                )
            }

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item noStyle shouldUpdate>
                        {(_form) => {
                            const fieldName = listField ? [listField.name, finalName].flat() : finalName
                            let _value = _form.getFieldValue(fieldName)
                            if (!_value && data.defaultNow) {
                                _form.setFieldValue(fieldName, new Date())
                            }

                            return (
                                <Form.Item
                                    {...listFieldProps}
                                    label={`${data.label || t`Question`} :`}
                                    name={fieldName}
                                    rules={[{ required: data.required || false, message: t`Ce champ est obligatoire` }]}
                                    tooltip={tooltip}
                                >
                                    <MomentToDate>
                                        <InputComponent
                                            size={"middle"}
                                            locale={locale_fr}
                                            style={{ width: "100%" }}
                                            disabledDate={disabledDate}
                                            picker={picker}
                                            format={format}
                                            showTime={withTime}
                                            showNow={showNow}
                                            inputReadOnly={component !== "TIME"}
                                            needConfirm={false}
                                        />
                                    </MomentToDate>
                                </Form.Item>
                            )
                        }}
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-date' + namespace,
        title: t`Champ date`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CalendarOutlined/>,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    range: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Plage de dates / heures`,
                        }
                    },
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                    defaultNow: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Sélectionner par défaut la date et l'heure du jour`,
                        }
                    },
                    dateFilter: {
                        type: "string",
                        uniforms: {
                            showIf: (data) => data.picker !== formPlugin.DATE_PICKER[3],
                            label: t`Filtreur de date`,
                            allowedValues: formPlugin.DATE_FILTER_SELECT,
                        },
                    },
                    picker: {
                        type: "string",
                        uniforms: {
                            label: t`Mode`,
                            allowedValues: formPlugin.DATE_PICKER,
                        },
                    },
                }
            },
        },
    }
}
